// @ts-nocheck
import * as React from 'react';
import { useState } from 'react';
import { Icon, LiveDemoTopBar, Mark } from '../components/LiveDemoChrome';
import { useLiveDemoSession } from '../hooks/useLiveDemoSession';

export function LoginA({ onProceed }) {
  const session = useLiveDemoSession();

  return (
    <div className="screen">
      <LiveDemoTopBar now="Session" />
      <div className="loginA">
        <div className="glow" />
        <div className="confirm-card">
          <img className="confirm-card__logo" src="/admissions-assured/soomuch-logo.svg" alt="Soomuch" />
          <p className="greet">Signed in · {new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" })}</p>
          <h2 className="who">Welcome back, {session.counsellor.split(" ")[0]}.</h2>
          <p className="role">{session.role} · {session.school}</p>

          <div className="ctx-rows">
            <div className="ctx-row">
              <div className="ic"><Icon name="parent" /></div>
              <div><div className="lab">Counsellor</div><div className="val">{session.counsellor}</div></div>
            </div>
            <div className="ctx-row">
              <div className="ic"><Icon name="command" /></div>
              <div><div className="lab">Institution</div><div className="val">{session.school}</div></div>
            </div>
            <div className="ctx-row">
              <div className="ic"><Icon name="sparkles" /></div>
              <div><div className="lab">Session type</div><div className="val">Live Demo Mode</div></div>
              <span className="session-pill live"><span className="ds-livedot" style={{ width: 7, height: 7 }} /> Live</span>
            </div>
          </div>

          <div className="glance">
            <div className="g"><b>7</b><span>Enquiries today</span></div>
            <div className="g"><b>14</b><span>Demos sent</span></div>
            <div className="g"><b>5/8</b><span>Weekly target</span></div>
          </div>

          <button className="btn btn-primary btn-lg confirm-card__cta" style={{ width: "100%" }} onClick={onProceed}>
            Begin new intake <Icon name="arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
}

export function LoginB({ onProceed }) {
  const session = useLiveDemoSession();
  const [src, setSrc] = useState("walkin");
  const sources = [
    { id: "walkin", t: "Walk-in", s: "On-campus today" },
    { id: "scheduled", t: "Scheduled", s: "Booked visit" },
    { id: "referral", t: "Referral", s: "Parent referred" },
  ];
  const srcLabel = sources.find((source) => source.id === src).t;

  return (
    <div className="screen">
      <div className="loginB">
        <div className="pane-dark">
          <div className="glow" />
          <svg className="orbital" viewBox="0 0 460 460" fill="none">
            <circle cx="230" cy="230" r="150" stroke="rgba(255,255,255,.12)" />
            <circle cx="230" cy="230" r="210" stroke="rgba(255,255,255,.08)" />
            <circle cx="230" cy="230" r="90" stroke="rgba(79,138,255,.35)" />
            <circle cx="80" cy="230" r="4" fill="#4f8aff" />
            <circle cx="230" cy="20" r="3" fill="rgba(255,255,255,.6)" />
          </svg>
          <Mark className="mark" />
          <h2>Every demo,<br /><span className="accent">prepared by intelligence.</span></h2>
          <p className="sub">Admissions Assured captures each family, builds a profile, and arranges the live demo before it begins.</p>
          <span className="livestrip"><span className="ds-livedot" /> 20 AI employees online · responding in real time</span>
          <div className="crest-b">
            <div className="badge">{session.badge}</div>
            <div style={{ marginTop: 14, fontSize: 15, fontWeight: 700 }}>{session.school}</div>
            <div style={{ fontSize: 12.5, color: "rgba(245,245,245,.55)", marginTop: 2 }}>{session.schoolSub}</div>
          </div>
        </div>

        <div className="pane-light">
          <span className="eyebrow"><Icon name="shield" /> Secure session</span>
          <div className="signedin">
            <div className="avatar">{session.initials}</div>
            <div><b>{session.counsellor}</b><br /><span>{session.role}</span></div>
            <span className="session-pill" style={{ marginLeft: "auto" }}><span className="ds-livedot" style={{ width: 7, height: 7 }} /> Live Demo Mode</span>
          </div>

          <div className="field-label">New demo session - enquiry source</div>
          <div className="seg">
            {sources.map((source) => (
              <div key={source.id} className={"opt" + (src === source.id ? " sel" : "")} onClick={() => setSrc(source.id)}>
                <b>{source.t}</b><span>{source.s}</span>
              </div>
            ))}
          </div>

          <div className="session-summary">
            Starting a <b>{srcLabel}</b> demo for <b>{session.school}</b>, handled by <b>{session.counsellor}</b>.
            The session is logged to today's live pipeline and personalised end-to-end.
          </div>

          <button className="btn btn-primary btn-lg" onClick={onProceed}>
            Start session · capture family <Icon name="arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
}
